






















import { Component, Prop, Mixins } from "vue-property-decorator";
import CurrenciesStore from "@/mixins/constants/currenciesStore";
import { ICurrency } from "@/models/constants";

@Component
export default class PartialPayment extends Mixins(CurrenciesStore) {
  @Prop({ required: true })
  public currencyId!: ICurrency["id"];

  @Prop({ default: 0 })
  public value!: number;

  @Prop({ default: false })
  public isDisabled!: boolean;

  public get currency(): ICurrency {
    return this.$_.find(this.currencies, ["id", this.currencyId]) as ICurrency;
  }

  public get totalAmount() {
    return this.value;
  }

  public set totalAmount(value) {
    this.$emit("input", value);
  }
}
